// extracted by mini-css-extract-plugin
export var avatarContainer = "_bp-0";
export var avatarTypingWave = "_bp-i";
export var gray = "_bp-f";
export var green = "_bp-c";
export var icon = "_bp-9";
export var image = "_bp-1";
export var lg = "_bp-6";
export var md = "_bp-5";
export var presenceDot = "_bp-b";
export var red = "_bp-d";
export var sm = "_bp-4";
export var status = "_bp-a";
export var typingDot = "_bp-h";
export var typingPill = "_bp-g";
export var xl = "_bp-7";
export var xs = "_bp-3";
export var xxl = "_bp-8";
export var xxs = "_bp-2";
export var yellow = "_bp-e";